import api from './utilBackoffice';

const controller = 'Proposta';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => api.Axios.GetParams(url, dto),
  ListarCanceladas: dto => api.Axios.GetParams(url + '/Canceladas', dto),
  ListarPendentePagamento: dto =>
    api.Axios.GetParams(url + '/PendentePagamento', dto),

  /* Pagas */
  ListarPagas: dto => api.Axios.GetParams(url + '/Pagas', dto),
  RequestDownloadPagas: dto =>
    api.Axios.Post(url + '/RequestDownloadPagas', dto),
  DownloadPagas: dto => api.Axios.DownloadExcelFile(url + '/DownloadPagas', dto)
  /* */
});
